import { Button, Card, DatePicker, Space } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { useState } from 'react';
import { RawRangeType } from '../types';

export type DateRangeFilterDropdownProps = {
  defaultValue?: RawRangeType;
  onApplyFilter: (values: RawRangeType) => void;
};

const DateRangeFilterDropdown = (props: DateRangeFilterDropdownProps) => {
  const { defaultValue, onApplyFilter } = props;
  const [values, setValues] = useState<RangePickerProps['value']>();
  const defaultFrom = defaultValue?.from ? dayjs(defaultValue.from) : undefined;
  const defaultTo = defaultValue?.to ? dayjs(defaultValue.to) : undefined;

  const onApply = () => {
    const [start, end] = values || [];
    onApplyFilter({
      from: start ? start.format('YYYY-MM-DD') : '',
      to: end ? end.format('YYYY-MM-DD') : '',
    });
  };

  return (
    <Card title="Date Range" size="small" className="font-figtree">
      <Space>
        <DatePicker.RangePicker defaultValue={[defaultFrom, defaultTo]} onChange={setValues} aria-label="date-range-picker" />
        <Button type="primary" onClick={onApply}>
          Apply
        </Button>
      </Space>
    </Card>
  );
};

export default DateRangeFilterDropdown;
